import { Box, styled } from '@mui/material';

interface DotProps {
  color: string;
  size?: number;
  showMargin?: boolean;
}

const Dot = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'color' && prop !== 'size' && prop !== 'showMargin',
})<DotProps>(({ theme, color, size = 6, showMargin }) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  backgroundColor: color,
  marginLeft: showMargin ? theme.spacing(1) : undefined,
}));

export default Dot;
